export const IS_MAC = window.navigator.userAgent.includes('Mac OS X');
export const IS_WINDOWS = window.navigator.userAgent.includes('Windows');
export const TERMINAL_CONTINUE = `${IS_WINDOWS ? '^' : '\\'}\n    `;
// we can't safely use `&` on windows, so we're just going to run the commands one after the other.
export const TERMINAL_COMMAND_SEP = IS_WINDOWS
  ? '\n'
  : ` && ${TERMINAL_CONTINUE}`;

export const keycodesModule = angular
  .module('Q.constants.keycodes', [])

  .constant('KeyCodes', {
    // Use $event.which === KeyCodes.KEY_NAME for correct matching
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    RETURN: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    INSERT: 45,
    DELETE: 46,
    COMMAND: 224,
    // some useful utility & display properties
    IS_MAC,
    COMMAND_KEY: IS_MAC ? 'Cmd' : 'Ctrl',
    isCommand(event) {
      return !!event[IS_MAC ? 'metaKey' : 'ctrlKey'];
    },
    isShift(event) {
      return !!event.shiftKey;
    },
    isAlt(event) {
      return !!event.altKey;
    },
    SYMBOLS: {
      COMMAND_KEY: IS_MAC ? '\u2318' : 'Ctrl',
      ALT_KEY: IS_MAC ? '\u2325' : 'Alt',
      CONTROL_KEY: IS_MAC ? '\u2303' : 'Ctrl',
      SHIFT_KEY: IS_MAC ? '\u21e7' : 'Shift',
      LEFT_ARROW: '\u2190',
      UP_ARROW_ARROW: '\u2190',
      RIGHT_ARROW: '\u2192',
      DOWN_ARROW: '\u2193',
      ENTER: IS_MAC ? '\u23CE' : 'Enter',
    },
  })

  .run(function ($rootScope, KeyCodes) {
    $rootScope.KeyCodes = KeyCodes;
  });
